<div class="ap-cr-header">
  <div class="ap-cr-row">
    <div class="ap-cr-row-empty"></div>
    <div class="time-shift-back ap-cr-header-border-box">
      <button kendoButton (click)="onBackClick()"
              [disabled]="!CanScrollLeft">
        <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltLeftIcon')"></kendo-svg-icon>
      </button>
    </div>
    <div class="ap-cr-flex-box"
         [style.overflow]="'hidden'"
         #YearScroller>
      <div class="ap-cr-cell-noselect ap-cr-header-border-box"
           [style.display]="'flex'"
           *ngFor="let year of yearInterval"
           [class.ap-cr-cell-header-year-marked]="year === 0"
           [class.ap-cr-cell-header-marked]="year === 0"
           [class.ap-cr-cell-marked]="year === 0"
           [class.ap-cr-border-left]="year === -1"
           [style.min-width.px]="columnWidth + (year === 0 ? -12 : -12)"
           [style.max-width.px]="columnWidth + (year === 0 ? -12 : -12)">
        <ap-responsive-text [text]="(currentYear+year).toString(10)"></ap-responsive-text>
        <ap-crop-rotation-filter [source]="fullItems | allCrops:year+1"
                                 [key]="'Description'"
                                 [mapKey]="'MainCrop'+(year+1)"
                                 [buildFilter]="createCropKeyFilter"
                                 [meta]="{year:year}"
                                 [filter]="filter"
                                 (filterChange)="filterChange.emit($event)"
        ></ap-crop-rotation-filter>
      </div>
    </div>
    <div class="time-shift-forward ap-cr-header-border-box">
      <button kendoButton (click)="onFutureClick()"
              [disabled]="!CanScrollRight">
        <kendo-svg-icon [icon]="ApKendoIconService.Get('caretAltRightIcon')"></kendo-svg-icon>
      </button>
    </div>
  </div>
  <div class="ap-cr-row-fields">
    <div class="ap-cr-header-cell-detail">
      <input type="checkbox"
             class="k-checkbox"
             [id]="'allCropFields_grid_selector'"
             [checked]="selectedFields && fields && selectedFields.length === fullItems.length && selectedFields.length !== 0"
             (change)="selectAllFields()" />
      <label class="k-checkbox-label ap-cr-flex-box-checkbox-11px"
             [for]="'allCropFields_grid_selector'"></label>
    </div>
    <div class="ap-cr-cell-clickable-noselect-34px ap-cr-header-border-box">

    </div>
    <div class="ap-cr-cell-clickable-noselect-50px ap-cr-header-border-box">
      <ap-responsive-text [text]="numberText"
                          (click)="sortByTNr()"
      ></ap-responsive-text>
      <ap-crop-rotation-sort [sort]="sort" [field]="'FieldNumber'" (click)="sortByTNr()"></ap-crop-rotation-sort>
      <ap-crop-rotation-filter [source]="fullItems"
                               [key]="'FieldNumber'"
                               [filterType]="filterTypes.RANGE"
                               [filter]="filter"
                               (filterChange)="filterChange.emit($event)"
      ></ap-crop-rotation-filter>
    </div>
    <div class="ap-cr-cell-clickable-noselect-60px ap-cr-header-border-box">
      <ap-responsive-text [text]="subNumberText"
                          (click)="sortBySubNr()"
      ></ap-responsive-text>
      <ap-crop-rotation-sort [sort]="sort"
                             [field]="'FieldSubNumber'"
                             (click)="sortBySubNr()"
      ></ap-crop-rotation-sort>
      <ap-crop-rotation-filter [source]="fullItems"
                               [key]="'FieldSubNumber'"
                               [filterType]="filterTypes.RANGE"
                               [filter]="filter"
                               (filterChange)="filterChange.emit($event)"
      ></ap-crop-rotation-filter>
    </div>
    <div class="ap-cr-cell-clickable-noselect-163px ap-cr-header-border-box">
      <ap-responsive-text [text]="nameText"
                          (click)="sortByName()"
      ></ap-responsive-text>
      <ap-crop-rotation-sort [sort]="sort"
                             [field]="'FieldName'"
                             (click)="sortByName()"
      ></ap-crop-rotation-sort>
      <ap-crop-rotation-filter [source]="fullItems"
                               [key]="'FieldName'"
                               [filter]="filter"
                               (filterChange)="filterChange.emit($event)"
      ></ap-crop-rotation-filter>
    </div>
    <div class="ap-cr-cell-clickable-noselect-50px ap-cr-header-border-box">
      <ap-responsive-text [text]="areaText"
                          (click)="sortByArea()"
      ></ap-responsive-text>
      <ap-crop-rotation-sort [sort]="sort" [field]="'AreaHa'"
                             (click)="sortByArea()"></ap-crop-rotation-sort>
      <ap-crop-rotation-filter [source]="fullItems"
                               [filterType]="filterTypes.RANGE"
                               [key]="'AreaHa'"
                               [filter]="filter"
                               (filterChange)="filterChange.emit($event)"
      ></ap-crop-rotation-filter>
    </div>
    <div class="ap-cr-flex-box"
         [style.overflow]="'hidden'"
         #DetailScroller>
      <div *ngFor="let year of yearInterval"
           [class.ap-cr-cell-header-marked]="year === 0"
           [class.ap-cr-cell-marked]="year === 0"
           [class.ap-cr-no-border-left]="year === 1"
           [style.min-width.px]="columnWidth + (year === 0 ? 0 : 0)"
           [style.max-width.px]="columnWidth + (year === 0 ? 0 : 0)"
           class="ap-cr-header-border-box">
        <ap-crop-rotation-detail-header-big [mainCropLabel]="'Nutrients_UserControls__MainCropAcronym' | translate"
                                            [mainCropStrawHarvestedLabel]="'Global__Straw' | translate"
                                            [mainCropYieldLabel]="'Global__UnitDt' | translate"
                                            [secondCropLabel]="'Nutrients_UserControl__SecondaryCropAcronym' | translate"
                                            [secondCropYieldLabel]="'Global__UnitDt' | translate"
                                            [isHighlighted]="year === 0"
        ></ap-crop-rotation-detail-header-big>
      </div>
    </div>
  </div>
</div>
